import { useCallback, useState } from 'react';

const useMoveRouteState = () => {
    const [movPopParams, setMovPopParams] = useState(null);
    const [selectedMoveRouteInfo, setSelectedMoveRouteInfo] = useState(null);
    const [selectedMoveRouteInfoItems, setSelectedMoveRouteInfoItems] = useState([]);

    const resetMoveRouteInfoItems = useCallback(() => {
        setSelectedMoveRouteInfoItems([]);
    }, []);

    return {
        movPopParams,
        setMovPopParams,
        selectedMoveRouteInfo,
        setSelectedMoveRouteInfo,
        selectedMoveRouteInfoItems,
        setSelectedMoveRouteInfoItems,
        resetMoveRouteInfoItems,
    };
};

export default useMoveRouteState;
